import React, { useState } from 'react';

// @mui
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

// core
import { TextInputBase } from '_core/components/TextInputBase';

export const PasswordInput = (props) => {
  const [show, setShow] = useState(false);

  return (
    <TextInputBase
      inputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              aria-label="toggle password visibility"
              onClick={() => setShow((v) => !v)}
              onMouseDown={(event) => event.preventDefault()}
            >
              {show ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        )
      }}
      {...props}
      type={show ? 'text' : 'password'}
    />
  );
};

PasswordInput.defaultProps = {};
PasswordInput.propTypes = {};
